import ProgramApis from '@/app/program/apis'
import createStoreWithContext from '@/utils/store/create-store-with-context'

const { withStore, useStore: useProgramRegistrations } = createStoreWithContext(
  (set, get, swrFields) => ({
    ...swrFields,
  }),
  () => ({
    key: `user-registrations`,
    fetcher: () => ProgramApis.getAllRegistrations(),
    storeKey: 'registrations',
  }),
)

export const withProgramRegistrationsStore = withStore

export default useProgramRegistrations
